import { environment } from 'environments/environment';

const ABSOLUTE_URL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;

const normalizePath = (path: string): string => {
  if (!path) {
    return '';
  }

  return path.startsWith('/') ? path : `/${path}`;
};

const shouldUseAppDomain = (): boolean => {
  const regex = /^(?:[a-zA-Z0-9]+-)?cart\.avery\.com$/;
  return typeof window !== 'undefined' && regex.test(window.location.hostname);
};

const getAppDomainBase = (): string => {
  return shouldUseAppDomain() ? environment.domain : '';
};

interface AppHrefOptions {
  forceAbsolute?: boolean;
}

export const getAppHref = (
  path?: string | null,
  options: AppHrefOptions = {}
): string => {
  const { forceAbsolute = false } = options;

  if (!path) {
    return forceAbsolute ? environment.domain : getAppDomainBase();
  }

  const trimmedPath = path.trim();

  if (ABSOLUTE_URL_REGEX.test(trimmedPath)) {
    return trimmedPath;
  }

  const base = forceAbsolute || shouldUseAppDomain() ? environment.domain : '';

  return `${base}${normalizePath(trimmedPath)}`;
};
